import { render, staticRenderFns } from "./HistoryBids.vue?vue&type=template&id=01240b52&"
import script from "./HistoryBids.vue?vue&type=script&lang=js&"
export * from "./HistoryBids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports